import { useState } from 'react';

import { GThirdPartyVehicleType } from 'src/graphql/types/generated';
import { VehicleChoice } from 'src/utils/thirdPartyDelivery';

type VehicleChoiceState = {
  // The class to send: the GM's pick, else the warehouse's default; undefined
  // while neither is known.
  vehicle: VehicleChoice | undefined;
  choose: (vehicle: VehicleChoice) => void;
};

// Follows the warehouse's default until the GM picks, so a default that loads
// late, or changes with the provider, never overwrites a pick.
export const useVehicleChoice = (
  warehouseDefault: VehicleChoice | undefined,
): VehicleChoiceState => {
  const [picked, setPicked] = useState<{ vehicle: VehicleChoice }>();
  return {
    vehicle: picked ? picked.vehicle : warehouseDefault,
    choose: (vehicle): void => setPicked({ vehicle }),
  };
};

// The default a prefill answer gives: the warehouse's class, or a cargo van when
// it names none. Undefined until the answer is in, and when the read failed,
// so the GM chooses rather than a guessed class going out.
export const warehouseVehicleDefault = (
  answered: boolean,
  preference: VehicleChoice | undefined,
): VehicleChoice | undefined =>
  answered ? preference ?? GThirdPartyVehicleType.CargoVan : undefined;
